<template>
    <div class="guide-download-app" v-if="dialogShow">
        <div class="dialogGreybg" >
            <!--场景为非1036弹窗-->
            <div class="senceDialog1 senceDialog2">
                <img class="chickenimg" src="https://static.yunjiglobal.com/qnUpload/frontend/smallCode/payDone-chicken.png"/>
                <div class="desc border-bottom-1px">
                    请前往云集App查看相关奖励
                    <img class="downloadts" src="https://static.yunjiglobal.com/qnUpload/frontend/smallCode/payDone-applypic.png"/>
                </div>
                <div class="btnBar">
                    <div @click="closeDialogSence" class="btnItemone redBtn">我知道了</div>
                </div>
            </div>
            <!--end场景为非1036弹窗-->
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
    }
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeDialogSence() {
      this.$emit('CLOSE_GUIDE_DOWNLOAD_APP_DIALOG', false)
    }
  }
}
</script>
<style scoped>
.dialogGreybg{
  background: rgba(0,0,0,0.5);
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index:2010;
}
.senceDialog1{
  top:50%;
  position: relative;
  width: 5.90rem;
  margin:-.37rem auto 0;
  background: #fff;
  font-size: .30rem;
  color:#333333;
  line-height: 1.75;
  border-radius: .16rem;
}
.senceDialog2{
 margin-top: -2.87rem;
}
.senceDialog2 .downloadts{
  width: 4.60rem;
  height: 4.40rem;
  margin:.20rem auto 0;
  display: block;
}
.senceDialog1 .desc{
  padding:.60rem .48rem .30rem; 
  text-align:center;
}
.senceDialog1 .desc.p-border-1px::after{
   border-color:#ccc;
 }
.senceDialog1 .chickenimg{
    width: 2.28rem;
    height:1.50rem;
    position: absolute;
    top:-1.46rem;
    left:1.80rem;
  } 
 .senceDialog1  .btnBar{
   margin-top:0;
   display:flex;
   flex-wrap:wrap;
   height: 1.00rem;
   border-radius: .16rem;
   overflow: hidden;
 }
 .senceDialog1 .btnBar .btnItemone{
    background:#fff;
    width: 100%;
    box-sizing: border-box;
    height: 1.00rem;
    line-height: 1.00rem;
    text-align: center;
    color: #888;
    font-size: .32rem;
    font-weight: 700;
 }
 .senceDialog1 .btnBar .btnItemone::after{
   border: none;
 }
 .senceDialog1 .btnBar .btnItemone.leftcalbtn{
    border-bottom-left-radius: 10px;
 }
 .senceDialog1 .btnBar .border-right-1px::before {
  transform: scaleY(1);
  border-left: 1px solid #eeeeee;
 }
 .senceDialog1 .btnBar .btnItemone.redBtn{
    color: #F10D3B;
    border-bottom-right-radius: 10px;
 }
 .border-bottom-1px {
     position: relative;
 }
 .border-bottom-1px:before {
    content: ' ';
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #eee;
    transform: scaleY(0.33);
}
</style>
